<template>
  <main>
    <Transition name="fade">
      <div v-if="page">
        <PageHeader :content="page.data.header"/>
        <!-- Uncomment to use search bar on this page-->
        <SearchBar v-model="search" />
        <ResourceList :resources="items as Post[]"/>
        <PageSections :sections="page.data.sections"/>
      </div>
    </Transition>
  </main>
</template>

<script lang="ts">
import {ViewDataMixin} from '@/views/mixins'
import {PageHeader, PageSections, ResourceList} from '@/components/sections'
import {usePageStore, usePostStore} from '@/stores'
import {SearchBar} from '@/components/blocks'
import { useSearch } from '@/composables'
import { ref } from 'vue'

export default {
  name: 'PostIndex',
  mixins: [ViewDataMixin],
  components: {PageHeader, PageSections, ResourceList, SearchBar},
  setup() {
    const posts = ref<Post[]>([])
    const {search, items} = useSearch(posts)
    return {search, items, posts}
  },
  data() {
    return {
      page: null as Page | null,
    }
  },
  methods: {
    async init() {
      const [page, posts] = await Promise.all([
        usePageStore().get('posts'),
        usePostStore().all()
      ])

      if (!page) {
        await this.$router.push({name: this.$routes.NOT_FOUND})
      }

      this.page = page
      this.posts = posts
    }
  }
}
</script>
